import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SairComponent } from './madu-components/sair/sair.component';
import { HomeComponent } from './madu-components/home/home.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { AppAsideComponent, AppFooterComponent, AppHeaderComponent, AppSidebarComponent, AppSidebarFooterComponent, AppSidebarFormComponent, AppSidebarHeaderComponent, AppSidebarMinimizerComponent, APP_SIDEBAR_NAV, AppLoadingComponent } from './theme-components';
import { LoginComponent } from './madu-components/login/login.component';
import { SimpleLayoutComponent, FullLayoutComponent } from './theme-containers';
import { AsideToggleDirective, NAV_DROPDOWN_DIRECTIVES, ReplaceDirective, SIDEBAR_TOGGLE_DIRECTIVES } from './theme-directives';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToasterModule } from 'angular2-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LogComponent } from './madu-components/log/log.component';
import { UsuariosComponent } from './madu-components/usuarios/usuarios.component';
import { ChartsModule } from 'ng2-charts';
import { defineLocale, ptBrLocale } from 'ngx-bootstrap/chronos';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TextMaskModule } from 'angular2-text-mask';
import { CnpjPipe } from './_pipes/cnpj.pipe';
import { FormsModule } from '@angular/forms';
import { EtquetasMarcopoloComponent } from './madu-components/etiquetas-marcopolo/etiquetas-marcopolo.component';
import { ModalEtiquetaMarcopoloModule } from './madu-components/modal-etiqueta-marcopolo/modal-etiqueta-marcopolo.module';
import { EtquetasMascarelloComponent } from './madu-components/etiquetas-mascarello/etiquetas-mascarello.component';
import { ModalEtiquetaMascarelloModule } from './madu-components/modal-etiqueta-mascarello/modal-etiqueta-mascarello.module';

defineLocale('pt-br', ptBrLocale);

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

const APP_COMPONENTS = [
  AppAsideComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
  AppLoadingComponent
]

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    SairComponent,
    HomeComponent,
    LoginComponent,
    LogComponent,
    UsuariosComponent,
    CnpjPipe,
    EtquetasMarcopoloComponent,
    EtquetasMascarelloComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToasterModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ChartsModule,
    TabsModule.forRoot(),
    TextMaskModule,
    FormsModule,
    ModalEtiquetaMarcopoloModule,
    ModalEtiquetaMascarelloModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
